import React, { useState, useEffect } from "react";
import { II } from "../../components/common/Icons";
import api from "../../services/api";
import T from "../../assets/styles/theme";import { formatDateOnly } from "../../utils/helpers";import "../../assets/styles/PM/PMPermsPg.css";

function PMPermsPg() {
  const [perms, setPerms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [suc, setSuc] = useState("");

  const fetchPerms = () => {
    api.getPMPermissionRequests().then((d) => {setPerms(Array.isArray(d) ? d : []);setLoading(false);}).catch(() => setLoading(false));
  };
  useEffect(fetchPerms, []);

  const handleAction = async (reqId, action) => {
    try {
      await api.handlePMPermission(reqId, action, "");
      setPerms((prev) => prev.map((p) => p.req_id === reqId ? { ...p, status: action, pm_status: action } : p));
      setSuc(`Permission ${action}`);
      setTimeout(() => setSuc(""), 4000);
    } catch (e) {alert("Error: " + e.message);}
  };

  const sChip = (s) => {
    if (s === "approved") return "chip-ok";
    if (s === "rejected") return "chip-dn";
    return "chip-wn";
  };

  return (
    <div>
      <div className="sec">Permission Requests</div>
      {suc && <div className="toast">{II("chk", 16, { c: "#2563eb" })} {suc}</div>}
      <div className="cd">
        <div className="cd-h">
          <div className="cd-t">All Permission Requests</div>
          <div className="cd-s">{perms.filter((p) => p.status === "pending").length} pending</div>
        </div>
        <div className="cd-b pmpermspg-inline-1">
          <table className="tbl">
            <thead>
              <tr><th>Employee</th><th>Role</th><th>Date</th><th>From</th><th>To</th><th>Hours</th><th>Reason</th><th>Status</th><th>Action</th></tr>
            </thead>
            <tbody>
              {loading ?
              <tr><td colSpan="9" style={{ "--pmpermspg-1-color": T.textMuted }} className="pmpermspg-dyn-1">Loading...</td></tr> :
              perms.length === 0 ?
              <tr><td colSpan="9" style={{ "--pmpermspg-2-color": T.textMuted }} className="pmpermspg-dyn-2">No permission requests</td></tr> :
              perms.map((p) =>
              <tr key={p.req_id || p.id}>
                  <td className="pmpermspg-inline-2">{p.name || "—"}</td>
                  <td className="pmpermspg-inline-3">{p.user_role || "—"}</td>
                  <td className="pmpermspg-inline-4">{formatDateOnly(p.date)}</td>
                  <td className="pmpermspg-inline-5">{p.from_time}</td>
                  <td className="pmpermspg-inline-6">{p.to_time}</td>
                  <td>{p.hours || "—"}</td>
                  <td className="pmpermspg-inline-7">{p.reason || "—"}</td>
                  <td><span className={"chip " + sChip(p.status)}>{p.status}</span></td>
                  <td>
                    {p.status === "pending" ?
                  <div className="pmpermspg-inline-8">
                        <button className="btn btn-s btn-ok pmpermspg-inline-9" onClick={() => handleAction(p.req_id, "approved")}>
                          {II("chk", 12)} Approve
                        </button>
                        <button className="btn btn-s btn-dn pmpermspg-inline-10" onClick={() => handleAction(p.req_id, "rejected")}>
                          {II("x", 12)} Reject
                        </button>
                      </div> :
                  <span style={{ "--pmpermspg-3-color": T.textMuted }} className="pmpermspg-dyn-3">—</span>}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>);

}

export default PMPermsPg;
